"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var baseRoute = '/rate-service/v1';
exports.Routes = {
    RATES_CRUD: "".concat(baseRoute, "/rates"),
    IMPORT_CSV: "".concat(baseRoute, "/csv/import"),
    EXPORT_CSV: "".concat(baseRoute, "/csv/export"),
    EXPORT_MASTER_CSV: "".concat(baseRoute, "/csv/master")
};
//# sourceMappingURL=Rates.consts.js.map